import {KTIcon} from '../../../../_metronic/helpers'
const MessageModalHeader = ({
  setOpenMessageModal,
  type
}) => {  
  return (
    <div className='modal-header'>
      <h2 className='fw-bolder'>Create a new {type}</h2>

      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-users-modal-action='close'
        onClick={() =>  {
          setOpenMessageModal(false)
        }}
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>
    </div>
  )
}

export {MessageModalHeader}
